export function capitalizeFirstLetter(str: string | null): string {
  if (!str || !str.length) return str || '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

